import { NAME as MUTATION_ERROR, MutationError } from 'errors/mutation';
import { NAME as NETWORK_ERROR, NetworkError } from 'errors/network';
import {
  NAME as WALLET_ACCESS_ERROR,
  WalletAccessError,
} from 'errors/walletAccess';
import type { Await } from 'types';

import { NAME as BANK_APPROVAL_ERROR, BankApprovalError } from './bankApproval';
import {
  NAME as MIGRATOR_APPROVAL_ERROR,
  MigratorApprovalError,
} from './migratorApproval';

const errors = [
  BANK_APPROVAL_ERROR,
  MIGRATOR_APPROVAL_ERROR,
  MUTATION_ERROR,
  NETWORK_ERROR,
  WALLET_ACCESS_ERROR,
] as const;

export type AppError = (typeof errors)[number];

function isAppError(errorName: string): errorName is AppError {
  return errors.includes(errorName as any);
}

export function errorWrapper<T extends (...args: any[]) => any>(
  fn: T,
  rescueFrom?: AppError[]
): (...args: Parameters<T>) => Promise<{
  error?: { name: AppError; message: string };
  result?: Await<ReturnType<T>>;
}> {
  return async (...args: Parameters<T>) => {
    try {
      const result = await fn(...args);
      return { result };
    } catch (error: any) {
      const { name, message } = error;
      if (isAppError(name) && (rescueFrom || errors).includes(name))
        return { error: { name, message } };

      throw error;
    }
  };
}

export {
  BankApprovalError,
  MigratorApprovalError,
  MutationError,
  NetworkError,
  WalletAccessError,
};
